import { render, staticRenderFns } from "./eyeClose.vue?vue&type=template&id=fad40264&"
import script from "./eyeClose.vue?vue&type=script&lang=js&"
export * from "./eyeClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports